/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Select } from '@atoms';
import Form from '@organisms/Form';

const LanguageSelector = ({ defaultLanguage, ...props }) => {
  const [languageIndex, setLanguageIndex] = React.useState('en');

  const placeholder = '- Choose a language -';
  const languageMap = [
    {
      id: 'en',
      label: 'English',
    },
    {
      id: 'fr',
      label: 'French',
    },
    {
      id: 'es',
      label: 'Spanish',
    },
    {
      id: 'zh',
      label: 'Chinese',
    },
    {
      id: 'pt',
      label: 'Portuguese',
    },
    {
      id: 'ar',
      label: 'Arabic',
    },
    {
      id: 'tr',
      label: 'Turkish',
    },
    {
      id: 'ru',
      label: 'Russian',
    },
  ];

  const languageMapENOnly = [
    {
      id: 'en',
      label: 'English',
    },
  ];

  const setLang = defaultLanguage ? languageMapENOnly : languageMap;

  return (
    <Form.Item {...props}>
      <Select
        value={languageIndex}
        disabled={defaultLanguage}
        placeholder={placeholder}
        onSelect={setLanguageIndex}
        style={{ width: '100%' }}
      >
        {setLang.map(({ label, id }, idx) => (
          <Select.Option key={idx} value={id}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default LanguageSelector;
